module.exports = __webpack_public_path__ + "static/media/smilingfemaledoctors.d9209176.webp";